import { useEffect, useState } from 'react';
import { getNetworkStatus, onNetworkChange } from '../lib/capacitor';

/**
 * Slim "you're offline" strip that sits in normal flow above the TopBar.
 * Earlier versions used `position: fixed` with `z-index: 9999`, which
 * overlaid the topnav and intercepted clicks on header controls (e.g. the
 * report editor's save-state Retry chip). Rendering inline pushes the
 * shell down by the banner's height instead.
 */
export function NetworkStatusBanner() {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    getNetworkStatus().then((status) => setIsOnline(status.connected));
    const listener = onNetworkChange((connected) => setIsOnline(connected));
    return () => {
      listener.then((l) => l.remove());
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        backgroundColor: '#fef3c7',
        color: '#78350f',
        textAlign: 'center',
        padding: '6px 16px',
        fontSize: '13px',
        fontWeight: 500,
        borderBottom: '1px solid #fcd34d',
      }}
    >
      You're offline. Changes will retry automatically when you're back online.
    </div>
  );
}
